import './List.scss';

import PropTypes from 'prop-types';
import React from 'react';

const List = ({ type, children }) => {
	return type === 'unordered' ? <ul className='react__list'>{children}</ul> : <ol className='react__list'>{children}</ol>;
};

List.propTypes = {
	type: PropTypes.oneOf(['unordered', 'ordered']),
	children: PropTypes.node.isRequired
};

List.defaultProps = {
	type: 'unordered'
};

export default List;
